import { Meteor } from 'meteor/meteor';
import { Mongo } from 'meteor/mongo';
import { DeclareMethod } from '/imports/methods';
import { Doc } from '/imports/types';

export interface SavedForm extends Doc {
  key: string;
  userId: string;
  orgId: string;
  data: any;
  expires: Date;
}
export const SavedForms = new Mongo.Collection<SavedForm>('savedForms');

export const getSavedFormForKey = DeclareMethod<string, SavedForm>('getSavedFormForKey');
export const upsertSavedFormForKey = DeclareMethod<{key: string, data: any}, void>('upsertSavedFormForKey');
export const deleteSavedFormForKey = DeclareMethod<string, void>('deleteSavedFormForKey');

Meteor.isServer && Meteor.startup(async () => {
  await SavedForms.createIndexAsync({ key: 1, userId: 1, orgId: 1 });
  await SavedForms.createIndexAsync({ expires: 1 });
});
